import type { FC, ReactNode } from 'react'
import { createPortal } from 'react-dom'

const Head: FC<{ children?: ReactNode }> = ({ children }) =>
  createPortal(children, document.head)

export default Head
